module.exports = __webpack_public_path__ + "static/img/15.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/15.png
// module id = W5aS
// module chunks = 0